import { useContext } from 'react';
import { searchValueContext } from './context';

export const useSearchValueMethods = () => {
  const searchValueMethods = useContext(searchValueContext);
  return searchValueMethods;
};
